const styles = (theme) => ({
  // root: {
  //   backgroundColor: theme.palette.background.dark,
  //   minHeight: '100%',
  //   paddingTop: theme.spacing(5),
  //   paddingBottom: theme.spacing(3),
  // },
  root: {
    width: '100%',
    backgroundColor: 'transparent',
  },
  media: {
    height: 140,
    backgroundColor: '#FFF',
    borderRadius: '20px',
  },
})

export default styles
